const methods = new Set(['options', 'get', 'head', 'post', 'put', 'delete', 'patch', 'search', 'trace', 'connect']);

export default methods;
